export default "__VITE_ASSET__Bwp63rqJ__"